export default __webpack_public_path__ + "static/media/dep1_0.affa0e0b.jpg";